<template>
  <div>
    <div class="head">
      <el-breadcrumb style="margin-left:20px" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/processManager/targetResponsibility/position' }">岗位责任书</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.params.id ? "编辑" : "新增" }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm formBox"
        size="small"
      >
        <el-form-item label="责任书标题" prop="resTitle">
          <el-input v-model="ruleForm.resTitle" placeholder="请输入责任书标题" />
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0">
          <el-col :span="12">
            <el-form-item label="部门" prop="resDepId">
              <el-select v-model="ruleForm.resDepId" placeholder="请选择部门" style="width: 100%" @change="departChange">
                <el-option v-for="item in departList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="岗位" prop="resJobId">
              <el-select v-model="ruleForm.resJobId" placeholder="请选择岗位" style="width: 100%" @change="jobChange">
                <el-option v-for="item in jobList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0">
          <el-col :span="12">
            <el-form-item label="年度" prop="yeas">
              <el-date-picker
                v-model="ruleForm.yeas"
                type="year"
                value-format="yyyy"
                style="width: 100%"
                placeholder="选择年" />
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="附件" prop="aaa">
          <el-upload
            class="upload-demo"
            action="/v1/responsibilitybook/uploadFile"
            :on-remove="handleRemove"
            multiple
            :limit="1"
            :on-exceed="handleExceed"
            :on-change="handleChange"
            :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input type="textarea" :rows="3" v-model="ruleForm.remarks" placeholder="请输入指标内容" />
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0">
          <el-col :span="12">
            <el-form-item label="制定部门" prop="proDepId">
              <el-select
                v-model="ruleForm.proDepId"
                placeholder="请选择部门"
                style="width: 100%"
                @change="departChangeZD"
              >
                <el-option v-for="item in departList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="制定人" prop="proEmpId">
              <el-select
                v-model="ruleForm.proEmpId"
                placeholder="请选择制定人"
                style="width: 100%"
                @change="user($event, 1)"
              >
                <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="制定日期" prop="creationTime">
          <el-date-picker
            v-model="ruleForm.creationTime"
            type="date"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: calc(50% - 60px)"
          />
        </el-form-item>
        <el-form-item label-width="100%" style="padding-left: 120px">
          <el-divider slot="label">
            <span style="font-size: 16px;color: #666666">审核人</span>
          </el-divider>
        </el-form-item>
        <el-form-item label-width="0" style="margin-bottom: 0">
          <el-col :span="12">
            <el-form-item label="部门领导" prop="depHeadEmpId">
              <el-select
                v-model="ruleForm.depHeadEmpId"
                placeholder="请选择部门领导"
                style="width: 100%"
                @change="user($event, 2)"
              >
                <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司领导" prop="comLeaderEmpId">
              <el-select
                v-model="ruleForm.comLeaderEmpId"
                placeholder="请选择公司领导"
                style="width: 100%"
                @change="user($event, 3)"
              >
                <el-option v-for="item in companyLeaderList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item prop="definitionId" label="流程模板" v-if="!$route.params.id">
          <el-select :disabled="$route.params.id ? true : false" v-model="ruleForm.definitionId"
          placeholder="请添加" style="width:100%" @change="modelChange">
            <el-option
              v-for="m in modules"
              :key="m.id"
              :label="m.name"
              :value="m.definitionId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" style="width: 100%">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getAllDepartment, getDepartUser, responseBookAdd, getStaffList, responseBookEdit } from "@/api/processManager";
import { modulesList } from "@/api/model.js"
export default {
  name: "mainTargetAdd",
  data() {
    return {
      // 部门列表
      departList: [],
      // 岗位列表
      jobList: [],
      // 人员的列表
      userList: [],
      // 公司领导列表
      companyLeaderList: [],
      typeList: [
        { id: 0, name: '年度目标' },
        { id: 1, name: '季度目标' },
        { id: 2, name: '月度目标' },
      ],
      // 表单数据
      ruleForm: {},
      rules: {
        resTitle: [{ required: true, message: '请输入责任书标题' }],
        resDepId: [{ required: true, message: '请选择部门' }],
        resJobId: [{ required: true, message: '请选择岗位', trigger: 'blur' }],
        yeas: [{ required: true, message: '请选择年度' }],
        proDepId: [{ required: true, message: '请选择制定部门' }],
        proEmpId: [{ required: true, message: '请选择制定人', trigger: 'blur' }],
        creationTime: [{ required: true, message: '请选择制定日期' }],
        depHeadEmpId: [{ required: true, message: '请选择部门领导', trigger: 'blur' }],
        comLeaderEmpId: [{ required: true, message: '请选择公司领导' }],
        definitionId: [{ required: true, message: '请选择' }]
      },
      fileList: [],
      modules: []
    };
  },
  created() {
    this.getDepart();
    this.getCompanyLeader();
    this.getModulesList()
    if(this.$route.params.id) {
      let obj = this.$route.params
      delete(obj.comAuditTime)
      delete(obj.comLeaderAudit)
      delete(obj.depAuditTime)
      delete(obj.depHeadAudit)
      delete(obj.producerExplain)
      delete(obj.comAuditStatus)
      delete(obj.depAuditStatus)
      this.ruleForm = obj
      let id = Number(obj.resDepId)
      // console.log(obj)
      if(obj.fileName !== '' && obj.fileName !== 'null' && obj.fileUrl !== '' && obj.fileUrl !== 'null') {
        let fileObj = {
          name: obj.fileName,
          response: {
            data: obj.fileUrl
          }
        }
        this.fileList.push(fileObj)
      }
      getAllDepartment().then(res => {
        this.departList = res.body.data;
        for(let i in this.departList) {
        if(this.departList[i].id === id) {
          console.log(111)
          this.jobList = this.departList[i].jobVos
        }
      }
      })
      getDepartUser({ demId: obj.proDepId }).then(res => {
        this.userList = res.body.data;
      })
    }
  },
  methods: {
    // 获取所有部门
    getDepart() {
      getAllDepartment().then(res => {
        this.departList = res.body.data;
      })
    },
    // 获取公司领导列表
    getCompanyLeader() {
      getStaffList({}).then(res => {
        this.companyLeaderList = res.body.data
      })
    },
    // 部门改变
    departChange(id) {
      let obj = this.departList.find((item => {
        return item.id === id
      }))
      this.ruleForm.resJobId = '',
      this.ruleForm.resDepName = obj.name
      this.jobList = obj.jobVos
    },
    // 制定部门改变
    departChangeZD(id) {
      getDepartUser({ demId: id }).then(res => {
        this.userList = res.body.data;
        this.ruleForm.proEmpId = ''
        this.ruleForm.depHeadEmpId = ''
      })
    },
    // 岗位改变
    jobChange(id) {
      let obj = this.jobList.find((item) => {
        return item.id === id
      })
      this.ruleForm.resJobName = obj.name
      this.$forceUpdate()
    },
    user(id, status) {
      let obj = this.userList.find((item => {
        return item.id === id
      }))
      if(status === 1) {
        this.ruleForm.proName = obj.name
      }
      if(status === 2) {
        this.ruleForm.depHeadName = obj.name
      }
      if(status === 3) {
        let obj2 = this.companyLeaderList.find((item => {
          return item.id === id
        }))
        this.ruleForm.comLeaderName = obj2.name
      }
      this.$forceUpdate();
    },
    // 获取部门下面的人员
    getUser(id) {
      getDepartUser({ demId: id }).then(res => {
        this.ruleForm.departmentHeadEmpid = ''
        this.ruleForm.producerEmpId = ''
        this.userList = res.body.data;
      })
    },
    // 上传的事件
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.fileList = fileList
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handleChange(files, fileList) {
      this.fileList = fileList
    },

    getModulesList() {
      modulesList().then(res => {
        this.modules = res.body.data
      }) 
    },

    // 模板更改
    modelChange(a) {
      let obj = {}
      obj = this.modules.find(v => {
        return a === v.definitionId
      })
      this.ruleForm.key = obj.key
      // console.log(this.form)
    },

    // 保存的按钮
    submitForm() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let obj = {...this.ruleForm}
          if(this.fileList.length > 0) {
            obj.fileName = this.fileList[0].name
            obj.fileUrl = this.fileList[0].response.data
          }else{
            obj.fileName = "",
            obj.fileUrl = ""
          }
          // obj.examinedContent = JSON.stringify(this.tableData);
          if(this.$route.params.id) {
            // obj.creationTime = this.ruleForm.creationTime
            responseBookEdit({...obj}).then(res => {
              this.$message.success('编辑成功');
              this.$router.back();
            })
          }else{
            responseBookAdd({...obj}).then(res => {
              this.$message.success('添加成功');
              this.$router.back();
            })
          }
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped>
.formBox {
  padding-top: 15px;
  padding-right: 10%;
  width: 70%;
  margin: auto;
}
.formBox /deep/ .el-form-item {
  margin-bottom: 25px;
}
</style>